import React, { useEffect, useState } from 'react';
import './ScrollTopFab.css';

const ScrollTopFab = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 200);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      className={`scrolltop-fab ${visible ? 'is-visible' : ''}`}
      aria-label="Scroll to top"
      title="Scroll to top"
      onClick={scrollToTop}
    >
      <svg
        className="scrolltop-fab-icon"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M12 5 5 12l1.41 1.41L11 8.83V20h2V8.83l4.59 4.58L19 12l-7-7Z"
        />
      </svg>
    </button>
  );
};

export default ScrollTopFab;
